import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Divider
} from '@mui/material';
import {
  Face as FaceIcon,
  PersonSearch as PersonSearchIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ReferencePersonsList from './ReferencePersonsList';

/**
 * Component to integrate face recognition in the image upload page
 */
const FaceRecognitionCard = ({ sessionId, refreshTrigger }) => {
  const navigate = useNavigate();

  const handleNavigateToFaceRecognition = () => {
    if (sessionId) {
      navigate(`/face-recognition/${sessionId}`);
    }
  };

  if (!sessionId) {
    return null;
  }

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">
            <FaceIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Face Recognition
          </Typography>
          <Button
            variant="outlined"
            size="small"
            startIcon={<PersonSearchIcon />}
            onClick={handleNavigateToFaceRecognition}
          >
            Open Face Recognition
          </Button>
        </Box>
        
        <Typography variant="body2" color="text.secondary" paragraph>
          Tag people in your photos to find them across all images in this session.
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <ReferencePersonsList 
          sessionId={sessionId} 
          refreshTrigger={refreshTrigger}
        />
      </CardContent>
    </Card>
  );
};

export default FaceRecognitionCard;
